var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSankalp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300.05 300.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#f1661a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 150.02,
    cy: 150.02,
    r: 150.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.8,150A149.78,149.78,0,0,1,47.29,259l1.7-.92,35.66-20.21,60.62-35.66s9.51-3.56,10.7-25-11.89-10.7-11.89-10.7-11.89,5.94-28.53,16.64c-16.64,13.08-14.26-3.56-14.26-3.56V123.78c0-32.1,27.34-42.79,27.34-42.79l14.86-7.73s22-11.89,22.58-28.53c.73-20.2-14.26-8.32-14.26-8.32s-33.29,19-65.38,36.85c-33.28,15.45-38,38-38,38s-7.13,25-14.26,54.68-20.21,34.47-20.21,34.47L10,203.34A149.81,149.81,0,0,1,252.3,40.59l-1.24.67L215.4,61.47,154.78,97.13s-9.51,3.56-10.7,25S156,132.79,156,132.79s11.89-5.94,28.53-16.64c16.64-13.08,14.26,3.56,14.26,3.56v55.87c0,32.1-27.34,42.79-27.34,42.79l-14.86,7.73S134.57,238,134,254.63c-.73,20.2,14.26,8.32,14.26,8.32s33.29-19,65.38-36.85c33.28-15.45,38-38,38-38s7.13-25,14.26-54.68,20.21-34.47,20.21-34.47l3.7-2.73A149.39,149.39,0,0,1,299.8,150Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSankalp);
export default __webpack_public_path__ + "static/media/Sankalp.ec376920028cfd2ceee1ed9847403b07.svg";
export { ForwardRef as ReactComponent };